import { createFeatureSelector, createSelector } from '@ngrx/store';
import { VOIVODESHIP_FEATURE_KEY } from '../keys';
import { VoivodeshipState } from '../reducers/voivodeship-list.reducer';

const selectVoivodeshipState = createFeatureSelector<VoivodeshipState>(VOIVODESHIP_FEATURE_KEY);

export const selectVoivodeships = createSelector(selectVoivodeshipState, (state: VoivodeshipState) => state.voivodeship);
export const selectVoivodeshipsLoaded = createSelector(selectVoivodeshipState, (state: VoivodeshipState) => state.loaded);
export const selectVoivodeshipsLoading = createSelector(selectVoivodeshipState, (state: VoivodeshipState) => state.loading);
